// AI-CONTEXT: See docs/features/compare-two-periods.md
//
// Delta between a primary KPI value (A) and its compare baseline (B), for the
// "A vs B + Δ" KPI compare view. `abs` = A - B; `pct` = change relative to the
// baseline B (null when B is 0, since the percentage is undefined); `direction`
// drives the up/down/flat colour. Returns an empty delta when either value is
// not a finite number, so the UI can hide the change indicator.

/**
 * @typedef {object} KpiDelta
 * @property {number|null} abs - Absolute change A - B, or null when undefined
 * @property {number|null} pct - Percentage change vs baseline B (1 decimal), or null
 * @property {'up'|'down'|'flat'} direction
 */

const EMPTY = { abs: null, pct: null, direction: 'flat' }

/**
 * @param {number} a - Primary period value
 * @param {number} b - Compare (baseline) period value
 * @returns {KpiDelta}
 */
const computeKpiDelta = (a, b) => {
    if (typeof a !== 'number' || typeof b !== 'number'
        || !Number.isFinite(a) || !Number.isFinite(b)) {
        return { ...EMPTY }
    }

    const abs = a - b
    const direction = abs > 0 ? 'up' : abs < 0 ? 'down' : 'flat'
    const pct = b === 0 ? null : Math.round((abs / b) * 1000) / 10

    return { abs, pct, direction }
}

export default computeKpiDelta
